import { useState } from 'react';
import { Download, X } from 'lucide-react';
import { usePwaInstall } from './usePwaInstall';
import IosHintModal from './IosHintModal';

const DISMISS_KEY = 'apisai_install_banner_dismissed';

/**
 * Delikatny, zamykany baner „Zainstaluj ApisAI na telefonie" — tylko na mobile (lg:hidden).
 * Pokazywany raz (dismiss zapamiętany w localStorage). Ukryty gdy zainstalowane/niedostępne.
 */
export default function InstallBanner() {
  const { available, installed, promptInstall } = usePwaInstall();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });
  const [iosHint, setIosHint] = useState(false);

  if (installed || dismissed || !available) return null;

  const handleClick = async () => {
    const r = await promptInstall();
    if (r === 'ios') setIosHint(true);
  };
  const handleDismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* noop */ }
  };

  return (
    <>
      <div
        className="lg:hidden mx-3 mt-3 rounded-xl bg-gradient-to-r from-[var(--apisai-primary)] to-orange-500 text-white px-3 py-2.5 flex items-center gap-3 shadow-sm"
        data-testid="install-banner"
      >
        <div className="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0">
          <Download className="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[13px] font-bold leading-tight">Zainstaluj ApisAI na telefonie</p>
          <p className="text-[11px] text-white/85 leading-tight truncate">Szybki dostęp z ekranu głównego + powiadomienia</p>
        </div>
        <button
          onClick={handleClick}
          data-testid="install-banner-cta"
          className="flex-shrink-0 text-[12px] font-bold bg-white text-[var(--apisai-primary)] rounded-lg px-3 py-1.5 hover:bg-white/90 transition-colors"
        >
          Zainstaluj
        </button>
        <button onClick={handleDismiss} data-testid="install-banner-dismiss" aria-label="Zamknij" className="flex-shrink-0 text-white/80 hover:text-white">
          <X className="w-4 h-4" />
        </button>
      </div>
      {iosHint && <IosHintModal onClose={() => setIosHint(false)} />}
    </>
  );
}
